var pageOverlay;

var init = function() {
  pageOverlay = document.getElementById("page-overlay");

  if (pageOverlay == undefined) {
    return;
  }

  pageOverlay.ontouchmove = preventScroll;
  pageOverlay.onclick = closeOverlay;
};

var preventScroll = function(e) {
  e.preventDefault();
  e.stopPropagation();
};

// var assignClickClose = function(handler) {
//   pageOverlay.addEventListener("click", handler);
// };

var openOverlay = function(e, className) {
  if (className == undefined) {
    className = "overlay-active";
  }
  document.body.classList.add(className);
};

var closeOverlay = function(e, className) {
  if (className == undefined) {
    className = "overlay-active";
  }
  document.body.classList.remove(className);
};

export default {
  init: init,
  // onClick: assignClickClose,
  open: openOverlay,
  close: closeOverlay
}
